/**
 * Footer: salto de línea después de "Second Floor" en .footer__block-info
 */
function breakAfterSecondFloor() {
  document.querySelectorAll('.footer__block-info').forEach(function (el) {
    if (el.dataset.breakSecondFloor === '1') return;
    el.dataset.breakSecondFloor = '1';

    el.innerHTML = el.innerHTML.replace(
      /(Second\s+Floor)(,?)(\s*)/i,
      '$1$2<br/>$3'
    );
  });
}

/**
 * Producto: si existe el encabezado de recomendaciones (.h5.product-recommendations-heading
 * o h5.product-recommendations-heading), inserta .product-youtube-video justo antes; si no,
 * antes del acordeón de descripción.
 */
function moveProductYoutubeBeforeDescription() {
  document.querySelectorAll('.product-detail__information').forEach(function (info) {
    var video = info.querySelector('.product-youtube-video');
    if (!video) return;

    function insertBeforeRecommendationsHeading() {
      var heading =
        info.querySelector('.h5.product-recommendations-heading') ||
        info.querySelector('h5.product-recommendations-heading');
      if (heading && heading.parentNode && video.parentNode) {
        heading.parentNode.insertBefore(video, heading);
        return true;
      }
      return false;
    }

    if (insertBeforeRecommendationsHeading()) return;

    var blocks = info.querySelectorAll('collapsible-block');
    var descriptionCollapsible = null;

    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].querySelector('.product_description')) {
        descriptionCollapsible = blocks[i];
        break;
      }
    }

    // Respaldo: primer collapsible cuyo h3 contiene "Description" (por si cambia el markup)
    if (!descriptionCollapsible) {
      for (var j = 0; j < blocks.length; j++) {
        var heading = blocks[j].querySelector('.collapsible-heading, h3');
        if (heading && /description/i.test(heading.textContent.trim())) {
          descriptionCollapsible = blocks[j];
          break;
        }
      }
    }

    if (descriptionCollapsible && descriptionCollapsible.parentNode) {
      descriptionCollapsible.parentNode.insertBefore(video, descriptionCollapsible);
    }

    // El bloque puede entrar después (render diferido / sección): reubicar cuando exista
    if (
      !info.querySelector('.h5.product-recommendations-heading') &&
      !info.querySelector('h5.product-recommendations-heading')
    ) {
      var obs = new MutationObserver(function () {
        if (insertBeforeRecommendationsHeading()) {
          obs.disconnect();
        }
      });
      obs.observe(info, { childList: true, subtree: true });
      setTimeout(function () {
        obs.disconnect();
      }, 12000);
    }
  });
}

/**
 * Solo dentro de .product-detail__information: oculta collapsible-block si
 * .collapsible-content_inner no tiene contenido real (sin texto, sin img/embeds clave).
 */
function hideEmptyCollapsibleBlocks(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('collapsible-block').forEach(function (block) {
    if (!block.closest('.product-detail__information')) return;

    var inner = block.querySelector('.collapsible-content_inner');
    var empty = false;

    if (!inner) {
      empty = true;
    } else {
      var clone = inner.cloneNode(true);
      clone.querySelectorAll('script, style').forEach(function (n) {
        n.remove();
      });
      if (clone.querySelector('img, iframe, video, svg, picture, table, canvas')) {
        empty = false;
      } else {
        var text = clone.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
        empty = text === '';
      }
    }

    if (empty) {
      block.setAttribute('hidden', '');
      block.style.display = 'none';
    } else {
      block.removeAttribute('hidden');
      block.style.display = '';
    }
  });
}

/**
 * You May Also Like: lista de consultas a probar (título con ruido: comillas, #, SKUs, etc.).
 */
function ymalMeaningfulTokens(title) {
  if (!title || typeof title !== 'string') return [];
  var stop = {
    a: 1,
    an: 1,
    the: 1,
    and: 1,
    or: 1,
    of: 1,
    for: 1,
    with: 1,
    to: 1,
    in: 1,
    on: 1,
    el: 1,
    la: 1,
    los: 1,
    las: 1,
    de: 1,
    y: 1
  };
  var t = title.toLowerCase();
  t = t.replace(/[\u201c\u201d\u2018\u2019®™]/g, ' ');
  t = t.replace(/[^a-z0-9áéíóúñü\s-]/gi, ' ');
  var raw = t.split(/\s+/).filter(Boolean);
  var out = [];
  var seenTok = {};
  for (var i = 0; i < raw.length; i++) {
    var w = raw[i];
    if (w.length < 2) continue;
    if (stop[w]) continue;
    if (/^\d+$/.test(w)) continue;
    if (/^\d{4,}$/.test(w)) continue;
    if (seenTok[w]) continue;
    seenTok[w] = true;
    out.push(w);
  }
  return out;
}

function ymalBuildSearchQueries(title, productType, productVendor, tagsCsv) {
  var queries = [];
  var tokens = ymalMeaningfulTokens(title);

  if (tokens.length > 0) {
    var byLen = tokens.slice().sort(function (a, b) {
      return b.length - a.length;
    });
    var topLong = byLen.slice(0, 3).join(' ').trim();
    if (topLong) queries.push(topLong);
    var firstThree = tokens.slice(0, 3).join(' ').trim();
    if (firstThree && firstThree !== topLong) queries.push(firstThree);
    if (byLen[0]) queries.push(byLen[0]);
    if (byLen[1] && byLen[1] !== byLen[0]) queries.push(byLen[0] + ' ' + byLen[1]);
  }

  if (productType && String(productType).trim()) {
    queries.push(String(productType).trim());
  }
  if (productVendor && String(productVendor).trim()) {
    queries.push(String(productVendor).trim());
  }
  if (tagsCsv && String(tagsCsv).trim()) {
    var tagList = String(tagsCsv)
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .filter(function (s) {
        return s.length > 1;
      });
    if (tagList[0]) queries.push(tagList[0]);
    if (tagList[0] && tagList[1]) queries.push(tagList[0] + ' ' + tagList[1]);
  }

  var sliceFallback = (title || '').trim().replace(/\s+/g, ' ').slice(0, 50);
  if (sliceFallback && tokens.length === 0) queries.push(sliceFallback);

  var seen = {};
  return queries.filter(function (q) {
    if (!q || String(q).length < 2) return false;
    var k = String(q).toLowerCase();
    if (seen[k]) return false;
    seen[k] = true;
    return true;
  });
}

function ymalDestroyCarouselSwiper(carousel) {
  if (carousel.globalSlide && typeof carousel.globalSlide.destroy === 'function') {
    carousel.globalSlide.destroy(true, true);
    carousel.globalSlide = null;
  }
}

function ymalShowYmalEmpty(root, carousel, emptyMsg, hideWhenEmpty) {
  if (carousel) carousel.style.display = 'none';
  if (emptyMsg) {
    emptyMsg.removeAttribute('hidden');
    emptyMsg.classList.remove('hidden');
  }
  if (hideWhenEmpty && root) root.style.display = 'none';
}

function ymalShowYmalSuccess(root, carousel, emptyMsg) {
  if (root) root.style.display = '';
  if (carousel) carousel.style.display = '';
  if (emptyMsg) {
    emptyMsg.setAttribute('hidden', '');
    emptyMsg.classList.add('hidden');
  }
}

function ymalParseSlidesFromSearchHtml(html) {
  var doc = new DOMParser().parseFromString(html, 'text/html');
  return (
    doc.querySelector('.ymal-search-slides__slides') ||
    doc.querySelector('[id^="shopify-section-"] .ymal-search-slides__slides')
  );
}

function ymalFetchSearchSection(searchPath, fragmentId, q) {
  var url =
    searchPath +
    (searchPath.indexOf('?') >= 0 ? '&' : '?') +
    'q=' +
    encodeURIComponent(q) +
    '&type=product' +
    '&options[prefix]=last' +
    '&options[unavailable_products]=last' +
    '&section_id=' +
    encodeURIComponent(fragmentId);
  return fetch(url).then(function (response) {
    if (!response.ok) throw new Error('YMAL search failed');
    return response.text();
  });
}

function ymalLoadSearchIntoCarousel(carousel) {
  if (!carousel || carousel.dataset.ymalLoaded === '1') return;

  var routes = window.routes || {};
  if (!routes.search_url) return;

  var root = carousel.closest('[data-ymal-root]');
  var title = carousel.getAttribute('data-product-title') || '';
  var productId = carousel.getAttribute('data-product-id');
  var productType = carousel.getAttribute('data-product-type') || '';
  var productVendor = carousel.getAttribute('data-product-vendor') || '';
  var productTags = carousel.getAttribute('data-product-tags') || '';
  var limit = parseInt(carousel.getAttribute('data-limit') || '4', 10);
  if (isNaN(limit) || limit < 1) limit = 4;
  var fragmentId = carousel.getAttribute('data-fragment-id') || 'ymal-search-slides';
  var hideWhenEmpty = root && root.getAttribute('data-hide-when-empty') === 'true';
  var emptyMsg = root && root.querySelector('[data-ymal-empty-msg]');
  var swiperWrapper = carousel.querySelector('[data-ymal-slides]');

  if (!swiperWrapper) return;

  var queries = ymalBuildSearchQueries(title, productType, productVendor, productTags);
  if (!queries.length) {
    carousel.dataset.ymalLoaded = '1';
    ymalShowYmalEmpty(root, carousel, emptyMsg, hideWhenEmpty);
    return;
  }

  var searchPath = routes.search_url;
  carousel.dataset.ymalLoading = '1';
  swiperWrapper.innerHTML = '';

  var pid = productId != null ? String(productId) : '';

  function applySlides(slidesEl) {
    var nodes = Array.prototype.slice.call(slidesEl.children);
    var kept = [];
    for (var i = 0; i < nodes.length && kept.length < limit; i++) {
      var node = nodes[i];
      var idEl = node.querySelector('[data-product-id]');
      var id = idEl && idEl.getAttribute('data-product-id');
      if (id && pid && id === pid) continue;
      kept.push(node);
    }
    return kept;
  }

  function finishSuccess(kept) {
    kept.forEach(function (node) {
      swiperWrapper.appendChild(node);
    });
    ymalDestroyCarouselSwiper(carousel);
    if (typeof carousel.initSlide === 'function') {
      carousel.initSlide();
    }
    if (typeof BlsLazyloadImg !== 'undefined' && BlsLazyloadImg.init) {
      BlsLazyloadImg.init();
    }
    if (typeof BlsAnimations !== 'undefined' && BlsAnimations.init) {
      BlsAnimations.init();
    }
    if (typeof initLazyloadItem === 'function') {
      initLazyloadItem();
    }
    carousel.dataset.ymalLoaded = '1';
    ymalShowYmalSuccess(root, carousel, emptyMsg);
  }

  function finishEmpty() {
    carousel.dataset.ymalLoaded = '1';
    ymalShowYmalEmpty(root, carousel, emptyMsg, hideWhenEmpty);
  }

  var index = 0;

  function tryNextQuery() {
    if (index >= queries.length) {
      finishEmpty();
      delete carousel.dataset.ymalLoading;
      return;
    }
    var q = queries[index];
    index += 1;
    ymalFetchSearchSection(searchPath, fragmentId, q)
      .then(function (html) {
        var slidesEl = ymalParseSlidesFromSearchHtml(html);
        if (!slidesEl || !slidesEl.children.length) {
          tryNextQuery();
          return;
        }
        var kept = applySlides(slidesEl);
        if (kept.length === 0) {
          tryNextQuery();
          return;
        }
        finishSuccess(kept);
        delete carousel.dataset.ymalLoading;
      })
      .catch(function () {
        tryNextQuery();
      });
  }

  tryNextQuery();
}

function initProductYouMayAlsoLikeSearch(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('slide-section[data-ymal-carousel]').forEach(function (carousel) {
    if (carousel.dataset.ymalLoaded === '1' || carousel.dataset.ymalLoading === '1') return;

    var io = new IntersectionObserver(
      function (entries, observer) {
        if (!entries[0] || !entries[0].isIntersecting) return;
        observer.unobserve(carousel);
        ymalLoadSearchIntoCarousel(carousel);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    io.observe(carousel);
  });
}

function initFrontend() {
  breakAfterSecondFloor();
  moveProductYoutubeBeforeDescription();
  hideEmptyCollapsibleBlocks(document);
  initProductYouMayAlsoLikeSearch(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFrontend);
} else {
  initFrontend();
}

// Editor de temas (secciones que se recargan por AJAX)
document.addEventListener('shopify:section:load', function (ev) {
  var root = ev.target && ev.target.querySelectorAll ? ev.target : document;
  hideEmptyCollapsibleBlocks(root);
  moveProductYoutubeBeforeDescription();
  root.querySelectorAll('slide-section[data-ymal-carousel]').forEach(function (el) {
    delete el.dataset.ymalLoaded;
  });
  initProductYouMayAlsoLikeSearch(root);
});


